<div class="block-group-title" *ngIf="tableBlock.title">
    <h2 class="sub-title" [innerHTML]="tableBlock.title | translate | safe:'html'"></h2>
</div>
<div class="block-table">
    <compliance-table [datas]="tableBlock.data" [extendedData]="compteRenduDetaillUtilsService.CRDData" [items]="items" [footer]="tableBlock.footer" [tableOption]="{exportFileName:blockExport?.fileName}" [destroy$]="destroy$" #table></compliance-table>
</div>
